import { useCallback } from 'react';
import type { ReactNode } from 'react';
import { Flex, useDisclosure } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Button, Text } from '../../ui-components';
import { getPerksValue } from '../../utils/perks-utils';
import { PerksDrawer } from '../perks-drawer';

interface Props {
    id: string;
    price: number;
}
export const EarnPerksMessage: React.FC<Props> = ({ id, price }: Props) => {
    const { isOpen, onClose, onOpen } = useDisclosure();
    const component = useCallback(
        (chunks: ReactNode[]) => (
            <Button
                id="buy-box-perks-button"
                variant="text-button"
                color="slt-primary-green.1000"
                textStyle="bold"
                textSize="base"
                onClick={onOpen}
            >
                {chunks}
            </Button>
        ),
        [],
    );

    const perks = `$${getPerksValue(price)}`;

    return (
        <Flex>
            <Text id={`${id}-message`}>
                <FormattedMessage
                    id="buy.box.earn.perks"
                    defaultMessage="<component>Earn {perks} Perks</component> with this purchase."
                    values={{
                        component,
                        perks,
                    }}
                />
            </Text>

            <PerksDrawer id={`${id}-drawer`} isOpen={isOpen} onClose={onClose} />
        </Flex>
    );
};
